import {History} from '../../../graphql-typings/graphql';
import {SimpleFunction} from './simple-function';
import {FunctionName} from './chart-function-types';

export class CeilingFunction extends SimpleFunction {

  constructor() {
    super(FunctionName.CEL, 'Ceiling');
  }

  run(historyArray: History[]): History[] {
    return super.applySimpleFunction(Math.ceil, historyArray);
  }
}
